var $ = jQuery;

$(document).ready(function() {
  ella.init();  
});

$(window).resize(function() {
  if (window.isMobile){
    ella.initMobileMenu();
  }
});

// DISPLAYS/HIDES THE  'GO BACK TO TOP ARROW'
$(window).scroll(function() {
  if ($(this).scrollTop() > 200) {
    $('#back-top').fadeIn();
  } else {
    $('#back-top').fadeOut();
  }
});

var ella = {
  ellaTimeout: null,
  init: function() {
    this.initMobileMenu();
    this.initScrollTop();
    this.initModal();
    this.initProductAddToCart();
  },
  initMobileMenu: function() {
    if ($(".menu-block").is(':visible')) {
      if ($(".gf-menu-device-container").find("ul.gf-menu").size() == 0) {
        
        //  Adds the contents of the mobile hamburger menu
        $(".gf-menu-device-container").append($(".nav-bar .site-nav-container").html());
        
        
        $(".gf-menu-device-container .site-nav").addClass("gf-menu");
        $(".gf-menu-device-container .site-nav").removeClass("nav")

        var menuLeft = document.getElementById( 'cbp-spmenu-s1' ),
            hamburgerIcon = document.getElementById( 'hamburgerIcon' ),
            header = document.querySelector('.site-header'),
            body = document.body;

        hamburgerIcon.onclick = function() {
          var headerHeight = header.offsetHeight;
          this.classList.toggle('active');
          
          
          menuLeft.classList.toggle('cbp-spmenu-open');
          ella.preventScrolling();
          
          if(menuLeft.classList.contains("cbp-spmenu-open")){
            menuLeft.style.top = headerHeight + 'px';
            menuLeft.style.height = `calc(100% - ${headerHeight}px)`;
          } else {
            menuLeft.style.top = '2220px';
            menuLeft.style.height = "100%"
          }
        };
      }
      
      //CLOSES/OPEN THE ACCORDION MENUS ON MOBILE
      $(".site-nav-link .icon-dropdown-wrap").on('click', function() {
        if ($(this).hasClass("mobile-toggle-open")) {
          // $(this).parent().next().hide(700);
          $(this).parent().next().hide();
          // $(this).parent().next().hide({duration:700, queue: false});
          // $(this).parent().next().fadeOut(400)
          $(this).removeClass("mobile-toggle-open");
        } else {
          // $(this).parent().next().show(700);
          $(this).parent().next().show();
          // $(this).parent().next().show({duration:700, queue: false});
          // $(this).parent().next().fadeIn(700);
          $(this).addClass("mobile-toggle-open");
        }
      })
    }
  },
  showModal: function(selector) {    
    $(selector).css("display", "flex").fadeIn(500)
    
    if(selector.includes("ajax-error") || selector.includes("mobile-select-size-msg-container")){
      ella.ellaTimeout = setTimeout(function() {
        $(selector).fadeOut(500);
      }, 3000);
    }
  },
  checkItemsInDropdownCart: function() {
    if ($('#dropdown-cart .mini-products-list').children().length > 0) {
      //Has item in dropdown cart
      $('#dropdown-cart .no-items').hide();
      $('#dropdown-cart .has-items').show();
    } else {
      //No item in dropdown cart
      $('#dropdown-cart .has-items').hide();
      $('#dropdown-cart .no-items').show();
    }
  },
  initModal: function() {
    const doc_body = document.body
    const modal = document.getElementById("added-to-cart-modal");
    $('.continue-shopping').click(function(e) {
      clearTimeout(ella.ellaTimeout);
      modal.scrollTop = 0
      ella.preventScrolling();
      $('.ajax-success-modal').fadeOut(500);
    });
    $('.close-modal, .overlay, .addedToCart-close-modal').click(function(e) {
      ella.preventScrolling();
      modal.scrollTop = 0
      clearTimeout(ella.ellaTimeout);
      $('.ajax-success-modal').fadeOut(500);
    });
  },
  initDropDownCart: function() {
    if (window.dropdowncart_type == "click") {
      //click type  
      $('#cartToggle').click(function() {
        if ($('#dropdown-cart').is(':visible')) {
          $("#dropdown-cart").slideUp('fast');
        } else {
          $("#dropdown-cart").slideDown('fast');
        }
      });
    } else {
      //hover type
      if (!('ontouchstart' in document)) {
        $('#cartToggle').hover(function() {
          if (!$('#dropdown-cart').is(':visible')) {
            $("#dropdown-cart").slideDown('fast');
          }
        });
        $('.wrapper-top-cart').mouseleave(function() {
          $("#dropdown-cart").slideUp('fast');
        });
      } else {
        //mobile
        $('#cartToggle').click(function() {
          if ($('#dropdown-cart').is(':visible')) {
            $("#dropdown-cart").slideUp('fast');
          } else {
            $("#dropdown-cart").slideDown('fast');
          }
        });
      }
    }
    ella.checkItemsInDropdownCart();
    $('#dropdown-cart .no-items a').click(function() {
      $("#dropdown-cart").slideUp('fast');
    });
    $('#dropdown-cart .btn-remove').click(function(event) {
      event.preventDefault();
      var productId = $(this).parents('.item').attr('id');
      productId = productId.match(/\d+/g);
      Shopify.removeItem(productId, function(cart) {
        ella.doUpdateDropdownCart(cart);
      });
    });
  },
  closeDropdownCart: function() {
    if ($('#dropdown-cart').is(':visible')) {
      $("#dropdown-cart").slideUp('fast');
    }
  },
  initScrollTop: function() {
    $('#back-top').click(function() {
      $('body,html').animate({
        scrollTop: 0
      }, 400);
      return false;
    });
  },
  initProductAddToCart: function() {
    if(window.cart_type == "popup"){
      ella.cartPopup()
      ella.reloadSlickCarousel()
    } else {
      ella.cartDrawer()
      ella.reloadSlickCarousel()
    }
  },
  cartPopup: function(){
    ella.initDropDownCart()
    let addToCartButton = document.getElementById('product_add-to-cart');
    if(addToCartButton){
      addToCartButton.addEventListener('click', function(event){
        event.preventDefault();
        let variant_id = document.getElementById('getVariantID').value;
        
        if(variant_id){
          ella.preventScrolling()
          let selectedVariant = product.variants.filter(variant => variant.id == variant_id)
          const product_info = ella.getProductInfo(product ,selectedVariant)

          if ($(this).attr('disabled') != 'disabled') {
            if (!window.ajax_cart) {
              $(this).closest('form').submit();
            } else {
              ella.doAjaxAddToCart(product_info);
            }
          }

          /* ADWORDS REMARKETING PRODUCT ADDED TO CART */
          dataLayer.push({
            'event' : 'Product_Added_To_Cart',
            'eComm_variantid': selectedVariant[0].sku
          });


          return false; 
        } else {
          if(product.variants.length > 1){
            ella.showModal('#mobile-select-size-msg-container');
          }
        }
      });
    }
  },
  cartDrawer: function(){
    ella.addCartDrawerListeners()
    let addToCartButton = document.getElementById('product_add-to-cart');
    if(addToCartButton){
      addToCartButton.addEventListener('click', event => {
        event.preventDefault()
        const doc_body = document.body
        let variant_id = document.getElementById('getVariantID').value;
        
        if(variant_id){
          let selectedVariant = product.variants.filter(variant => variant.id == variant_id)
          const product_info = ella.getProductInfo(product ,selectedVariant)
          ella.doAjaxAddToCart(product_info, "pdp");
          
        }
      })
    }
  },
  getProductInfo: function(product, selectedVariant){
    if(product.type != "Gift Card"){
      var image = product.images[1] || product.images[0];
    } else {
      var image = selectedVariant[0].featured_image.src;
    }
    const product_info = {
      "variant_id": selectedVariant[0].id,
      "quantity": 1,
      "title": product.title,
      "size": product.variants.length > 1 && product.type != "Gift Cards" ? `${selectedVariant[0].option1}` : "",
      "price": `$${(Math.round((selectedVariant[0].price * .01) * 100) / 100).toFixed(2)}`,
      "style": `${product.vendor}`,
      "image": image 
    }
    return product_info
  },
  showLoading: function(elClass) {
    $(elClass).show();
  },
  hideLoading: function(elClass) {
    $(elClass).hide();
  },
  doAjaxAddToCart: function(product_info, source = null) {
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: 'quantity=' + product_info.quantity + '&id=' + product_info.variant_id,
      dataType: 'json',
      beforeSend: function() {
        if(source == "pdp"){
          ella.showLoading('.loading-modal');
        } else {
          ella.showLoading('.loading-cart-drawer');
        }
      },
      success: function(msg) {
        if(window.cart_type == "popup" ){
          ella.updateModalCart(product_info)
        } else {
          ella.updateDrawerCart(source)
        }
        ella.updateDropdownCart();
      },
      error: function(xhr, text) {
        if(source == "pdp"){
          ella.hideLoading('.loading-modal');
        } else {
          ella.hideLoading('.loading-cart-drawer');
        }
        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
        ella.showModal('.ajax-error-modal');
      },
      complete: function(){
        if(source == "pdp"){
          ella.hideLoading('.loading-modal');
        } else {
          ella.hideLoading('.loading-cart-drawer');
        }
      }
    });
  },
  ajaxUpdateCartItemQuantity: function (variantId, quantity){
    var formData = new FormData()
    ella.showLoading('.loading-cart-drawer')
    formData.append(`updates[${variantId}]`, quantity)
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
    })
    .then(response => {
        ella.updateDrawerCart()
        ella.hideLoading('.loading-cart-drawer')
        return response.json();
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  },
  updateModalCart: function(product_info){
    //product title
    $('.ajax-success-modal').find('.ajax-product-title').html(product_info.title);
    // product image
    $('.ajax-success-modal').find('.ajax-product-image').attr('src', product_info.image);
    $('.ajax-success-modal').find('.ajax-product-image').attr('alt', product_info.title);
    // hide the 'go to wishlist' button because this is the cart
    $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
    // show the 'go to cart' button because this is the cart. 
    $('.ajax-success-modal').find('.btn-go-to-cart').show();
    // product price
    $('.ajax-success-modal').find('.ajax-product-price').html(product_info.price);
    //product size
    $('.ajax-success-modal').find('.ajax-product-size').html(product_info.size);
    //product size
    // $('.ajax-success-modal').find('.ajax-product-style').html(style);
    //cart total
    let cartTotal;
    Shopify.getCart(function(cart){
        cartTotal = (Math.round((cart.total_price * .01) * 100) / 100).toFixed(2);
        
        $('.ajax-success-modal').find('.ajax-cart-total').html("$" + cartTotal);
        
        let cartItemCount = cart.item_count;
        let cartItemContent = cartItemCount > 1 ? cartItemCount + " Items" : cartItemCount + " Item";   
        
        // Insert item count
        $('.ajax-success-modal').find('#addedToCart-item-count').html(cartItemContent);
      });
      
      ella.showModal('.ajax-success-modal');
      $('#upsell_products_carousel').slick("refresh");
      // $('#upsell_products_carousel').slick("resize");
  },
  updateDrawerCart: async function(source = null){
    const cart_drawer_text = await fetch("/?section_id=cart-drawer")
    const text = await cart_drawer_text.text()

    const cart_drawer_html = document.createElement('div')
    cart_drawer_html.innerHTML = text

    // const newHtml = cart_drawer_html.querySelector("#cart-drawer-wrapper").innerHTML
    const newHtml = cart_drawer_html.querySelector(".cart-drawer-items-sections").innerHTML
    document.querySelector(".cart-drawer-items-sections").innerHTML = newHtml
    if(window.show_cart_product_recs){
      ella.reloadSlickCarousel()
    }
    if(source == "pdp"){
      ella.showDrawerCart()
    }
    ella.addCartDrawerListeners()
  },
  updateDropdownCart: function() {
    Shopify.getCart(function(cart) {
      ella.doUpdateDropdownCart(cart);
    });
  },
  doUpdateDropdownCart: function(cart) {
    var template = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';
    $('#cartCountMobile').text(cart.item_count); 
    $('#cartCountDesktop').text(cart.item_count); 
    /*Total price*/
    $('#dropdown-cart .summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
    $('#added-to-cart-modal .money.ajax-cart-total').html(Shopify.formatMoney(cart.total_price, window.money_format));

    let cartItemCount = cart.item_count;
    let cartItemContent = cartItemCount > 1 ? cartItemCount + " Items" : cartItemCount + " Item";   

    // Insert item count
    $('.ajax-success-modal').find('#addedToCart-item-count').html(cartItemContent);
    
    /*Clear cart*/
    $('#dropdown-cart .mini-products-list').html('');
    /*Add product to cart*/
    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = template;
        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{URL\}/g, cart.items[i].url);
        item = item.replace(/\{TITLE\}/g, cart.items[i].title);
        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
        item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
        $('#dropdown-cart .mini-products-list').append(item);
      }
      $('#dropdown-cart .btn-remove').click(function(event) {
        event.preventDefault();
        var productId = $(this).parents('.item').attr('id');
        productId = productId.match(/\d+/g);
        Shopify.removeItem(productId, function(cart) {
          ella.doUpdateDropdownCart(cart);
        });
      });
      if (ella.checkNeedToConvertCurrency()) {
        Currency.convertAll(window.shop_currency, jQuery('.currencies').val(), '#dropdown-cart span.money', 'money_format');
      }
    }
    ella.checkItemsInDropdownCart();
  },
  checkNeedToConvertCurrency: function() {
    var shopCurrency = window.shop_currency
    return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
  },
  imgDeferer: function (selector) {
    let imgDefer = document.querySelectorAll(selector);
    for (var i=0; i<imgDefer.length; i++) {
      let dataSrcAttribute = imgDefer[i].getAttribute('data-src');
      imgDefer[i].setAttribute('src', dataSrcAttribute);
    }
  },
  delayedImgDeferer: function(selector){
    setTimeout(function(){
      let imgDefer = document.querySelectorAll(selector);
      for (var i=0; i<imgDefer.length; i++) {
        let dataSrcAttribute = imgDefer[i].getAttribute('data-src');
        imgDefer[i].setAttribute('src', dataSrcAttribute);
      }  
    }, 3000);
  },
  showDrawerCart: function(){
    document.body.classList.toggle("cart-drawer-open");
    ella.preventScrolling();
  },
  openCloseCartDrawer: function() {
    // OPEN/CLOSE cart drawer
    let body = document.body
    const cart_drawer_btns = document.querySelectorAll(".cart-drawer-btn")
    cart_drawer_btns.forEach((element)=>{
        element.addEventListener("click", ella.showDrawerCart)
    })
  },
  itemQuantityUpdate: function (){
        const item_qty_input = document.querySelectorAll(".cart-drawer-item-qty")
        const addRemoveButtons = document.querySelectorAll(".cart-drawer-quantity")

        item_qty_input.forEach(element => {
            element.addEventListener("keypress", e => {
                if(e.key === "Enter"){
                    e.preventDefault()
                    const item_key = e.target.parentElement.dataset.variantKey
                    const max = Number(e.target.max)
                    const entered_value = Number(e.target.value)
                    let final_value = entered_value > max ? max : entered_value
                    ella.ajaxUpdateCartItemQuantity(item_key, final_value)
                }
            })
        })

        addRemoveButtons.forEach(element => {
            element.addEventListener("click", event => {
                const item_key = element.parentElement.dataset.variantKey
                const item_id = Number(element.parentElement.dataset.variantId)
                var item_qty = Number(element.parentElement.dataset.itemQuantity)
                const item_inventory = Number(element.parentElement.dataset.itemInventory)

                if(element.classList.contains('cart-drawer-quantity-plus')){
                    item_qty++
                } else {
                    item_qty--
                }
                ella.ajaxUpdateCartItemQuantity(item_key, item_qty)
            })
        })
  },
  addCartDrawerListeners: function(){
    ella.openCloseCartDrawer()
    Shopify.getCart(function(cart) {
      $('#cartCountMobile').text(cart.item_count); 
      $('#cartCountDesktop').text(cart.item_count); 
      if(cart.item_count > 0) {
        ella.itemQuantityUpdate()
        ella.updateShippingProgress(cart);
        // Shopify.StorefrontExpressButtons.initialize();
        Shopify.PaymentButton.init();
        if(window.show_cart_product_recs){
          ella.productRecCartUpdate();
        }
        if(window.show_cart_drawer_discount_input){
          ella.cartDrawerDiscountCode(); 
        }
        document.querySelector(".cart-drawer-items-sections").classList.remove("cart-drawer-empty-cart-wrapper")
      } else {
        document.querySelector(".cart-drawer-items-sections").classList.add('cart-drawer-empty-cart-wrapper')
        document.querySelector(".cart-drawer-header").innerText = "0 Items: $0"
      }
    });
  },
  updateShippingProgress: function(cart){
    const free_shipping_bar = document.getElementById("free-shipping-progress")
    const cart_total = document.querySelector(".cart-drawer-header")
    const cart_subtotal = cart.items_subtotal_price / 100
    const header_text = cart.item_count == 1 ? "Item:": "Items:"
    cart_total.innerText = `${cart.item_count} ${header_text} $${cart_subtotal}`
    const free_shipping = 125
    let free_shipping_threshold = ((cart_subtotal - 0) * 100) / (free_shipping - 0)
    free_shipping_threshold = free_shipping_threshold > 100 ? 100 : free_shipping_threshold;
    free_shipping_bar.style.width = `${free_shipping_threshold}%`
  },
  reloadSlickCarousel: function(){
    if(window.show_cart_product_recs){
      $("#upsell_products_carousel").slick({
        mobileFirst: true,
        infinite: false,
        swipeToSlide: true,
        slidesToShow: 2
      });
    }
  },
  preventScrolling: function(){
    document.body.classList.toggle("prevent-scrolling");
  },
  productRecCartUpdate: function(){
    const addRemoveButtons = document.querySelectorAll(".product-rec-item-qty")

    addRemoveButtons.forEach(element => {
      element.addEventListener("click", event => {
          if(element.classList.contains('cart-drawer-quantity-plus')){
            let currentValue = Number(element.previousElementSibling.value)
            element.previousElementSibling.value = currentValue + 1
        } else {
            let currentValue = Number(element.nextElementSibling.value)
            if(currentValue > 1){
              element.nextElementSibling.value = currentValue - 1
            }
        }
      })
    })
    ella.productRecAddToCart()
  },
  productRecAddToCart: function(){
    const product_recs_btns = document.querySelectorAll(".product-rec-add-to-cart-btn");
    product_recs_btns.forEach(btn => {
      btn.addEventListener("click", function(e){
        e.preventDefault()
        let product_info = {
          quantity: e.target.previousElementSibling.children[1].value,
          variant_id: e.target.getAttribute("data-product-id")
        }
        ella.doAjaxAddToCart(product_info)
      })
    });
  },
  cartDrawerDiscountCode: function(){
    const discount_input_field = document.querySelector(".cart-drawer__discount_field_wrapper");
    const discount_sbmt_btn = document.getElementById("submit_discount_code");
    const discount_field_el = document.querySelector("#cart-drawer__promo-code-label");
    discount_input_field.addEventListener("keyup", e => {
      if(discount_input_field.value  == "") {
        discount_sbmt_btn.addAttribute("disabled")
      } else {
        discount_sbmt_btn.removeAttribute("disabled")
      }
    });

    discount_field_el.addEventListener("click", e => {
      document.getElementById("cart-item__discount-input").classList.toggle("hide-discount")
      document.getElementById("cart-item__discount-input").classList.toggle("flex-element")
    })
  }
}